module.exports = __webpack_public_path__ + "media/startup.f8aeac73.mp3";